<template>
    <div>
        <h4 class="mb-3">Nom du groupe</h4>
        <b-input
            v-model="form.name"
            size="sm"
            class="mb-3"
        />
        <b-btn variant="primary"
               @click="updateClientGroup"
               :disabled="form.name==='' || form.name===null">
            <i class="fas fa-fw fa-save mr-2" />Enregistrer
        </b-btn>
        <b-btn variant="secondary" @click="this.back">
            <i class="fas fa-fw fa-times mr-2" />Annuler
        </b-btn>
    </div>
</template>

<script>
import Formatter from '../../../common/mixins/Formatter'
import loading from '../../../common/components/loading'

export default {
    name: 'EditClientGroup',

    components: {
        loading
    },

    mixins: [Formatter],

    props: {
        clientGroup: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            form: {
                name: ''
            }
        }
    },

    computed: {
        disableSubmit() {
            return this.form.name === '' || this.form.name === null
        },
        baseUrl() {
            return document.head.querySelector('meta[name="base-url"]').content
        }
    },

    created() {
        this.initForm()
    },

    methods: {
        initForm() {
            this.form.name = this.clientGroup.name
        },

        async updateClientGroup() {
            try {
                await axios.put('/clientGroups/' + this.clientGroup.id, this.form)
                this.back()
            } catch (error) {
                //
            }
        },

        back() {
            window.location.href = this.baseUrl + '/pilotage-activite/groupes'
        }
    }
}
</script>

<style scoped></style>
